import { useCallback, useState } from "react";
import { useAuth, ValidatorProvider } from "react-admin-base";
import { LoadingButton, Validator } from "react-admin-base-bootstrap";
import { CardBody } from "reactstrap";
import { Input } from "reactstrap";
import { Row } from "reactstrap";
import { Col } from "reactstrap";
import { CardTitle } from "reactstrap";
import { CardFooter } from "reactstrap";
import { Label } from "reactstrap";
import { FormGroup } from "reactstrap";
import { CardHeader } from "reactstrap";
import { Card } from "reactstrap";
import { Form } from "reactstrap";
import { useUser } from "../../Components/UserProvider";
import Swal from 'sweetalert2';

function ResetPassword() {
	const [ api ] = useAuth();
	const user = useUser();
	
	const [ currentPassword, setCurrentPassword ] = useState('');
	const [ newPassword, setNewPassword ] = useState('');
	const [ newPassword2, setNewPassword2 ] = useState('');
	const [ loading, setLoading ] = useState(false);
	
	const hasPassword = !!user.password_updated_at;
	
	const updatePassword = useCallback(async (e) => {
		e.preventDefault();
		
		setLoading(true);
		try {
			await api.tokenized.post('/user/me/password', { current_password: currentPassword, new_password: newPassword });
			setCurrentPassword('');
			setNewPassword('');
			setNewPassword2('');
		} catch(e) {
			Swal.fire('Error', e.response.data.message, 'error');
		} finally {
			setLoading(false);
		}
	}, [currentPassword, newPassword, setLoading, setCurrentPassword, setNewPassword, setNewPassword2, api]);
	
	return <ValidatorProvider>
		<Form onSubmit={updatePassword}>
  			<Card>
  			<CardHeader>
				<CardTitle><b>{hasPassword ? "Change password" : "Set password"}</b></CardTitle>
  			</CardHeader>
  			<CardBody>
				{ hasPassword ?
	  				<FormGroup>
						<Label>Current password</Label>
						<Validator name="current_password" type="required">
		  					<Input type="password"
								value={currentPassword || ''}
								onChange={a => setCurrentPassword(a.currentTarget.value)}
								autoComplete="current-password"
								disabled={loading}
		  					/>
						</Validator>
	  				</FormGroup>
					: <p>
	  					You do not have a password registered in our system. If you want to login to the system with email (user.email) and password combination, you can set a password bellow
					</p>}
			
					<FormGroup>
	  					<Label>New password</Label>
	  					<Validator name="password" type="required">
							<Input type="password"
		  					value={newPassword || ''}
		  					onChange={a => setNewPassword(a.currentTarget.value)}
		  					autoComplete="new-password"
							  disabled={loading}
							/>
	  					</Validator>
					</FormGroup>
					<FormGroup>
	  					<Label>New password (again)</Label>
	  					<Validator name="password2" type={["required", { in: [ newPassword ] }]}>
							<Input type="password"
		  					value={newPassword2 || ''}
		  					onChange={a => setNewPassword2(a.currentTarget.value)}
		  					autoComplete="new-password"
							  disabled={loading}
							/>
	  					</Validator>
					</FormGroup>
  				</CardBody>
  				<CardFooter className="text-right">
					<LoadingButton block loading={loading} color="primary"><i className="fas fa-save mr-1" /> Save Password</LoadingButton>
  				</CardFooter>
			</Card>
		</Form>
	</ValidatorProvider>;
}

export default function Settings() {
	return <Row>
		<Col md="6">
			<ResetPassword />
		</Col>
	</Row>;
}
